import React from 'react';

const Downloads = ({ link }) => {
  return (
    <section id="downloads">
      {link ? (
        <iframe src={link} title="Downloads" width="100%" height="500px" />
      ) : (
        <p>No downloads available</p>
      )}
    </section>
  );
};

export default Downloads;